/* 🤖 this file was generated by svg-to-ts */
export const kzIconsArrowup: {
  name: 'arrowup';
  data: string;
} = {
  name: 'arrowup',
  data: `<svg viewBox="0 0 30 30" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M21.2.3c.7 0 1.1.2 1.6.7.9.9.9 2.3 0 3.2L12 15l10.8 10.8c.9.9.9 2.3 0 3.2-.9.9-2.3.9-3.2 0L7.2 16.6c-.5-.5-.7-.9-.7-1.6 0-.7.2-1.1.7-1.6L19.6 1c.4-.5.9-.7 1.6-.7Z" transform="rotate(90 14.988 14.988)" fill-rule="nonzero"/></svg>`
};
